export default "__VITE_ASSET__FR238f75__"